import { FC } from 'react'
import { MergedStoreCategoryProductsTopBanner } from '../../MergedStore/CategoryProducts/TopBanner/TopBanner'
import { PRINT_STORE_TEMPLATES_BANNER_QUERY } from '@dtx-company/flow-codegen/src/code/queries'
import { PrintStoreProductTemplatesBannerQuery } from '@dtx-company/flow-codegen/src/code/generated.types'
import { gqlFetcher } from '@dtx-company/inter-app/src/services/gqlFetcher'
import { useRouter } from 'next/router'
import useSWR from 'swr'

export const PrintStoreTemplatesTopBanner: FC = () => {
  const router = useRouter()
  const templatesCategoryId = router.query.templateCategoryId ?? ''
  const { data } = useSWR(
    () => (templatesCategoryId ? PRINT_STORE_TEMPLATES_BANNER_QUERY : null),
    query =>
      gqlFetcher<PrintStoreProductTemplatesBannerQuery>(query, {
        productCategoryIds: [templatesCategoryId]
      }),
    {
      revalidateOnFocus: false
    }
  )
  const templateBannerImageUrls =
    data?.printStoreProductCategories?.productCategories?.[0]?.templateBannerImageUrls ?? []
  const templateBannerText =
    data?.printStoreProductCategories?.productCategories?.[0]?.templateBannerText ?? ''
  const templateBannerTitle = data?.printStoreProductCategories?.productCategories?.[0]?.name ?? ''

  return (
    <MergedStoreCategoryProductsTopBanner
      bannerDescription={templateBannerText}
      bannerTitle={templateBannerTitle}
      bannerImageUrls={templateBannerImageUrls}
      isTemplate
    />
  )
}
